import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import * as PR from "../../prime-modules/index";
import { getAffiliateUsersList, affiliateActivateAPI, affiliateDeactivateAPI, createAffiliates, updateAffiliates, affiliateUserActivateAPI, getSettlementReport } from "../../services/api";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css'
import AdminFooter from "../layout/admin-footer";
import AdminHeader from "../layout/admin-header";
import { useSelector, useDispatch } from 'react-redux';
import { globalConfig } from "../../GlobalConfig";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from 'yup';
import * as utils from '../../utils';
import { QRCode } from 'react-qrcode-logo';
import "./Affiliates.scss"; //css
import { getCurrentTimestamp } from "../../utils/reuse";

const Affiliates = () => {
    const dispatch = useDispatch();
    const qrRef = useRef({});
    const adminData = useSelector(state => state.adminAuth.adminSessionData);
    const headers = useMemo(() => {
        return { sessionid: adminData.sessionId };
    }, [adminData.sessionId]);
    const appName = process.env?.REACT_APP_NAME;
    const affURL = process.env.REACT_APP_AFF_URL;
    //const affiliateCalendarRef = useRef(null);

    const [sortOrder, setSortOrder] = useState(-1);
    const [sortField, setSortField] = useState("name");
    const [sortKey, setSortKey] = useState("-name");

    const [users, setUsers] = useState([]);
    const toast = useRef();
    const [loading, setLoading] = useState(true);
    const currentYear = new Date().getFullYear();

    const [pageCount] = useState(globalConfig.pageCount);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(pageCount + 1);
    const [last, setLast] = useState(true);
    const [paging, setPaging] = useState(false);
    const [affiliateName, setAffiliateName] = useState('');
    const [affiliateUserName, setAffiliateUserName] = useState('');
    const [affiliateEmail, setAffiliateEmail] = useState('');
    const [affiliatePhone, setAffiliatePhone] = useState('');
    const [affiliateStatus, setAffiliateStatus] = useState([]);
    const [affiliatesData, setAffiliatesData] = useState(true);

    const [isDialogVisible, setDialogVisible] = useState(false);
    const [settlementReport, setSettlementReport] = useState(false);
    const [settlementAffiliateID, setSettlementAffiliateID] = useState("");
    const [createAffiliate, setCreateAffiliate] = useState(false);
    const [selectedAffiliateId, setSelectedAffiliateId] = useState(null);
    const [isDeactivationDialogVisible, setDeactivationDialogVisible] = useState(false)
    const [durationValue, setDurationValue] = useState('');
    const [discountValue, setDiscountValue] = useState('');
    const [commissionValue, setCommissionValue] = useState('');
    const [permanentDiscount, setPermanentDiscount] = useState('');
    const [b2bEnabled, setB2BEnabled] = useState('');
    const [discountError, setDiscountError] = useState('');
    const [durationError, setDurationError] = useState("");
    const [commissionError, setCommissionError] = useState("");
    const [affiliateNameActivate, setAffiliateNameActivate] = useState('');
    const [iso, setIso] = useState("gb"); // Default ISO for the UK (country code +44)
    const [phoneValue, setPhoneValue] = useState("");
    const [createLoading, setCreateLoading] = useState(false)
    const [enable, setEnable] = useState(false)
    const [disableText, setDisableText] = useState("")
    const [enableLoading, setEnableLoading] = useState(false)
    const [enableAPI, setEnableAPI] = useState({})
    const [affiliatePurchaseDate, setAffiliatePurchaseDate] = useState(null);
    const [affiliatePurchaseDateFrom, setAffiliatePurchaseDateFrom] = useState(null);
    const [affiliatePurchaseDateTo, setAffiliatePurchaseDateTo] = useState(null);
    const [affiliateData, setAffiliateData] = useState(true)
    const [searchTrigger, setSearchTrigger] = useState(Date.now());
    const [expandedRows, setExpandedRows] = useState([]);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [roles, setRoles] = useState("")
    const [allValues, setAllValues] = useState({commission: "", seeUser: false, type: 1, afId:"", isActive: false, affiliateUsers: {}, discount: ""})

    const [filterOpen, setFilterOpen] = useState(false);
    const toggleFilter = () => setFilterOpen(!filterOpen);

    const handleCheckboxChange = (rowData) => {
        const isActive = rowData?.isActive;
        setSelectedAffiliateId(rowData?.id);
        setPermanentDiscount(rowData?.permanentDiscountPercentage)
        setDurationValue(rowData?.revenueRecognitionPeriodInDays)
        setB2BEnabled(rowData?.b2bApiEnabled)
        setAffiliateNameActivate(rowData?.name)
        setAllValues({commission: rowData?.perOrderCommissionPercent, seeUser: rowData?.canSeeUsers, type: rowData?.type, afId: rowData?.afId, isActive: rowData?.isActive, affiliateUsers: rowData?.affiliateUsers, discount: rowData?.voucherCreationDiscountPercent})
        if (isActive) {
            setDeactivationDialogVisible(true);
        } else {
            setDialogVisible(true);
        }
    };

    const handleAPISwitchBox = (rowData, newValue) => {
        setEnable(true)
        setDisableText(rowData.b2bApiEnabled === true ? "Disable API" : "Enable API")
        const updatedRowData = { ...rowData, b2bApiEnabled: newValue }
        setEnableAPI(updatedRowData)
    };

    const handleDeactivate = () => {
        const response = (response) => {
            if (response.result === "SUCCESS") {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Affiliate has been successfully deactivated.",
                });
                getAllAffiliateUsers()
                setPermanentDiscount('')
                setDurationValue('')
                setDiscountValue('')
                setDiscountError('')
                setDurationError("")
                setExpandedRows([])
            } else if (response.result === "FAILED" && response.error) {
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
        };
        affiliateDeactivateAPI(selectedAffiliateId, dispatch, headers, response);
        setDeactivationDialogVisible(false);
    };

    const handleActivateSubmit = async () => {
        if ((allValues?.discount === null || allValues?.discount === '') && allValues.type === 1) {
            setDiscountError("Enter Discount Value");
            return;
        }  else if (allValues?.discount > 50 && allValues.type === 1) {
            setDiscountError("Discount value must be between 0% and 50%")
            return
        }else {
            setDiscountError("")
        }
        if ((allValues.commission === null || allValues.commission === '') && allValues.type === 0) {
            setCommissionError("Enter Commission Value");
            return;
        } else if (allValues.commission > 50 && allValues.type === 0) {
            setCommissionError("Commission value must be between 0% and 50%")
            return;
        } else {
            setCommissionError("");
        }
        const obj = {
            "revenueRecognitionPeriodInDays": allValues?.type === 0 ? durationValue : 0,
            "permanentDiscountPercentage":  allValues?.type === 0 ? permanentDiscount : 0,
            "b2bApiEnabled": b2bEnabled,
            "PerOrderCommissionPercent": allValues?.type === 0 ? allValues?.commission : 0,
            "canSeeUsers": allValues?.type === 0 ? false : allValues?.seeUser,
            "type": allValues?.type,
            "VoucherCreationDiscountPercent": allValues?.type === 0 ? 0 : allValues?.discount
        };
        const response = (response) => {
            if (response.result === "SUCCESS") {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Affiliate has been successfully activated.",
                });
                getAllAffiliateUsers()
                setDialogVisible(false);
                setPermanentDiscount('')
                setDurationValue('')
                setDiscountValue('')
                setDiscountError('')
                setCommissionError('')
            } else if (response.result === "FAILED" && response.error) {
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
        };
        affiliateActivateAPI(obj, dispatch, headers, selectedAffiliateId, response);
    }

    const handleActivateUserSubmit = (values) => {
        const isActivating = !values?.isActive;
        const obj = {
            "affiliateUser": {
                "id": values?.id,
                "name": values?.name,
                "email": values?.email,
                "isActive": isActivating,
                "role": values?.role === 0 ? 1 : values?.role
            }
        };
        const response = (response) => {
            if (response.result === "SUCCESS") {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Affiliate User has been successfully ${isActivating ? "activated" : "deactivated"}.`,
                });
                getAllAffiliateUsers()
            } else if (response.result === "FAILED" && response.error) {
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
        };
        affiliateUserActivateAPI(obj, dispatch, headers, response);
    }

    const onSortChange = (value) => {
        if (value.indexOf("!") === 0) {
            setSortOrder(-1);
            setSortField(value.substring(1, value.length));
            setSortKey(value);
        } else {
            setSortOrder(1);
            setSortField(value);
            setSortKey(value);
        }
        setPage(1);
        setOffset(0);
        setLimit(pageCount + 1);
        setAffiliateData(true)
    };

    const getAllAffiliateUsers = useCallback(async () => {
        let status;
        if (affiliateStatus.length === 1) {
        status = affiliateStatus[0] === 'active' ? true : false;
        } else if (affiliateStatus.includes('active') && affiliateStatus.includes('inactive')) {
        status = "";
        }
        if (affiliatesData && affiliateData) {
            setLoading(true);
            const sortOrderVal = (sortOrder === 1) ? "asc" : "desc";
            const obj = {
                offset: offset,
                limit: limit,
                sortField: sortField,
                sortOrder: sortOrderVal,
                affiliateName: affiliateName,
                name: affiliateUserName,
                email: affiliateEmail,
                phone: affiliatePhone,
                isActive: status === undefined ? "" : status,
                createdDateFrom: (affiliatePurchaseDateFrom !== null) ? affiliatePurchaseDateFrom : '',
                createdDateTo: (affiliatePurchaseDateTo !== null) ? affiliatePurchaseDateTo : '',
            };
            getAffiliateUsersList(obj, headers, dispatch, response => {
                if (response.result === 'SUCCESS') {
                    const list = response?.data;
                    const result = list !== null ? list.slice(0, pageCount) : [];
                    if (result.length > 0) {
                        setLast(list.length <= pageCount);
                        setUsers(result);
                        setPaging(true);
                    } else {
                        setUsers([]);
                        setLast(true);
                        setPaging(false);
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No records found' });
                    }
                } else {
                    setUsers([]);
                    setLast(true);
                    setPaging(false);
                    const error = response.error;
                    toast.current.show({ severity: error.severity, summary: 'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
                }
                setLoading(false);
            })
        }
    }, [affiliateData, sortOrder, offset, limit, sortField, affiliateName, affiliateUserName, affiliateEmail, affiliatePhone, headers, dispatch, pageCount, affiliatesData, affiliateStatus, affiliatePurchaseDateFrom, affiliatePurchaseDateTo])

    useEffect(() => {
        getAllAffiliateUsers()
    }, [getAllAffiliateUsers, searchTrigger])

    const affiliatesDataHeader = (field, label, selector) => {
        return (
            (sortField !== field) ?
                <>
                    <li onClick={(e) => onSortChange(field)} className={selector}><span>{label}<i className="pi pi-sort-alt"></i></span> </li>
                </> :
                <>
                    {(sortKey === field) ?
                        <>
                            <li onClick={(e) => onSortChange('!' + field)} className={selector}><span className="selectedList">{label}<i className="pi pi-sort-amount-up-alt"></i></span> </li>
                        </> :
                        <li onClick={(e) => onSortChange(field)} className={selector}><span className="selectedList">{label}<i className="pi pi-sort-amount-down"></i></span> </li>
                    }
                </>
        );
    }

    const handleFormSubmit = (values) => {
        setCreateLoading(true)
        if ((discountValue === null || discountValue === '') && values.type === "1") {
            setDiscountError("Enter Discount Value");
            setCreateLoading(false); 
            return;
        } else if (discountValue > 50) {
            setDiscountError("Discount value must be between 0% and 50%")
            setCreateLoading(false);
            return
        } else {
            setDiscountError("")
        }
        if ((commissionValue === null || commissionValue === '') && values.type === "0") {
            setCommissionError("Enter Commission Value");
            setCreateLoading(false); 
            return;
        } else if (commissionValue > 50 && values.type === "0") {
            setCommissionError("Commission value must be between 0% and 50%")
            setCreateLoading(false);
            return;
        } else {
            setCommissionError("");
        }
        if ((durationValue === null || durationValue === '') && values.type === "0") {
            setDurationError("Enter revenue recognition period");
            setCreateLoading(false);
            return;
        } else {
            setDurationError("");
        }

        const parsedDiscount = discountValue === '' ? 0 : discountValue;
        const parsedCommission = commissionValue === '' ? 0 : commissionValue;
        const setPermanentDiscount = values.type === "0" ? permanentDiscount : 0;

        const obj = {
            ...(values.type !== "2" && {
                "affiliate": {
                    "afId": values.affiliateId,
                    "websites": values.websites,
                    "permanentDiscountPercentage": setPermanentDiscount,
                    "revenueRecognitionPeriodInDays": durationValue === '' || undefined ? 0 : durationValue,
                    "VoucherCreationDiscountPercent": parsedDiscount,
                    "b2bApiEnabled": values.b2bApiEnabled,
                    "type": values.type === "" ? 0 : Number(values.type),
                    "PerOrderCommissionPercent": parsedCommission,
                    "canSeeUsers": values.canSeeUsers === "show" ? true : false,
                },
            }),
            "affiliateName": values.affiliateName,
            "affiliateUser": {
                "firstName": values.name,
                "email": values.email,
                "phone": { "callingCode": values.callingCode, "localPhoneNumber": phoneValue },
                "role": (values.role === undefined || "" || roles === 0) ? 1 : Number(values.role)
            }
        };
        const response = (response) => {
            setCreateLoading(false)
            if (response.result === "SUCCESS") {
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: "Affiliate has been successfully created.",
                });

                getAllAffiliateUsers()
                setCreateAffiliate(false);
                setDurationValue('')
                setDiscountValue('')
                setDiscountError('')
                setDurationError("")
                setCommissionValue("")
                /* setPermanentDiscount('') */
                setCommissionError("")
                formik2.resetForm()
            } else if (response.result === "FAILED" && response.error) {
                setCreateLoading(false)
                const error = response.error;
                toast.current?.show({
                    severity: error.severity,
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary,
                });
            }
        };
        createAffiliates(obj, headers, dispatch, response);
    }

    const paginate = (currentPage) => {
        setPaging(false);
        setPage(currentPage);
        const offsetVal = (currentPage - 1) * pageCount;
        const limitVal = pageCount + 1;
        setOffset(offsetVal);
        setLimit(limitVal);
        setAffiliateData(true)
    };

    const getUrl = (values) => {
        const baseUrl = (appName === 'data2go' || appName === 'esimcrew' || appName === 'pinoy' || appName === 'orzo') ? `${affURL}&referrer=afid=` : `${affURL}?afid=`;
        return `${baseUrl}${values}`;
    };

    const handleCopyClipboard = (values) => {
        const url = getUrl(values);
        navigator.clipboard.writeText(url)
        toast.current.show({
            severity: 'success',
            summary: 'Copied',
            detail: `Affiliate Link copied to clipboard!`,
            life: 3000,
        });
    };

    const downloadQRCode = async (id) => {
        const canvas = qrRef.current[id].querySelector('canvas');
        const image = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = image;
        link.download = 'affiliate_qrcode.png';
        link.click();
        /*  const affiliateLink = getUrl(affiliateLinks);
         try {
           const qrCodeDataUrl = await QRCode.toDataURL(affiliateLink);
           const link = document.createElement('a');
           link.href = qrCodeDataUrl;
           link.download = 'affiliate_qr_code.png'; // Filename for the downloaded QR code
           document.body.appendChild(link);
           link.click();
           document.body.removeChild(link);
         } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: "Failed to generate QR code" });
         } */
    };

    const getRoleName = (role) => {
        switch (role) {
            case 1:
                return "Admin";
            case 2:
                return "Finance";
            case 3:
                return "Voucher Manager";
            case 4:
                return "Voucher Viewer";
            default:
                return "-";
        }
    };

    const removeLeadingZero = (value) => value.replace(/^0+/, "");

    // Initial values for Form 1
    const [initialValues1] = React.useState({
        searchAffiliateName: affiliateName,
        searchUserName: affiliateUserName,
        searchAffiliateEmail: affiliateEmail,
        searchAffiliatePhone: affiliatePhone,
        searchAffiliateStatus: affiliateStatus,
        searchPurchaseDate: affiliatePurchaseDate
    });

    // Initial values for Form 2
    const [initialValues2] = React.useState({
        affiliateId: '',
        name: '',
        lastName: '',
        email: '',
        phoneNumber: "",
        callingCode: "+44",
        websites: [],
        b2bApiEnabled: false,
        type: "",
        canSeeUsers: false,
        affiliateName: "",
        role: ""
    });

    const validationSchema1 = Yup.object().shape({
        searchAffiliateName: Yup.string().trim(),
        searchUserName: Yup.string().trim(),
        searchAffiliateEmail: Yup.string().trim().email('Invalid email'),
        searchAffiliatePhone: Yup.string().trim(),
    });

    const validationSchema2 = (roles) => Yup.object().shape({
        name: Yup.string()
            .min(3, 'Name must be at least 3 characters')
            .max(50, 'Name must be 50 characters or less')
            .required('Name is required'),
        affiliateName: Yup.string()
            .min(3, 'Business/Company  Name must be at least 3 characters')
            .max(50, 'Business/Company  Name must be 50 characters or less')
            .required('Business/Company  Name is required'),
        lastName: Yup.string()
            .max(50, 'Last name must be 50 characters or less')
            .notRequired(),
        email: Yup.string()
            .email('Invalid email address')
            .max(100, 'Email must be 100 characters or less')
            .required('Email is required'),
        phoneNumber: Yup.string()
            .matches(/^\+?[1-9]\d{1,14}$/, "Invalid Phone number")
            .notRequired(),
        callingCode: Yup.string()
            .matches(/^\+\d+$/, "Invalid Calling Code")
            .notRequired(),
        type: Yup.number()
            .required('Please Select Type'),
        role: roles !== 0 && !!roles
            ? Yup.string().required('Please Select Role')
            : Yup.string().notRequired(),
    });

    const resetUserForm = () => {
        formik1.resetForm();
        setAffiliateName('');
        setAffiliateEmail('');
        setAffiliatePhone('');
        setAffiliateStatus([]);
        setPage(1);
        setOffset(0);
        setLimit(pageCount + 1);
        setAffiliateData(true)
        setAffiliatePurchaseDate(null)
        setAffiliatePurchaseDateFrom(null)
        setAffiliatePurchaseDateTo(null)
    }

    const onHideHandler = () => {
        formik2.resetForm()
        setCreateAffiliate(false)
        setDiscountValue("")
        setDurationValue("")
        setDurationError("")
        setCommissionValue("")
        setPermanentDiscount("")
        setCommissionError("")
        setIsReadOnly(false)
        setSettlementReport(false)
    }

    const resetHandler = () => {
        if (formik2.values.type === "2") {
            formik2.setValues({
                email: '',
                phoneNumber: "",
                callingCode: "+44",
                role: "",
                type: "2"
            });
        } else {
            formik2.resetForm()
            setDiscountValue("")
            setDurationValue("")
            setPermanentDiscount("")
            setPhoneValue("")
        }
    }

    const resetCommon = (e) => {
        formik2.setValues({
            type: e.value, // preserve the new type
            affiliateId: '',
            name: '',
            lastName: '',
            email: '',
            phoneNumber: "",
            callingCode: "+44",
            websites: [],
            b2bApiEnabled: false,
            affiliateName: "",
        });
        setDiscountValue("")
        setCommissionValue("")
        setPermanentDiscount("")
        setDurationValue("")
        formik2.setErrors({});
        formik2.setTouched({});
        setRoles(0)
    };

    const handleAffiliateSelectedStatus = (val) => {
        setAffiliateStatus(val);
        setAffiliatesData(false);
    }

    const handleSubmit = (formData) => {
        setAffiliatesData(true);
        setAffiliateName(trimFormData(formData.searchAffiliateName));
        setAffiliateUserName(trimFormData(formData.searchUserName));
        setAffiliateEmail(trimFormData(formData.searchAffiliateEmail));
        setAffiliatePhone(trimFormData(formData.searchAffiliatePhone));
        setPage(1);
        setOffset(0);
        setLimit(pageCount + 1);
        setAffiliateData(true)
        setSearchTrigger(Date.now())
    }

    // const handleAffiliateSelectedDate = (e) => {
    //     if (e.value === null) {
    //         setAffiliatePurchaseDate(null)
    //         setAffiliatePurchaseDateFrom(null);
    //         setAffiliatePurchaseDateTo(null);
    //     } else {
    //         const date = e.value;
    //         const fromDate = utils.modifyCustomerDate(date[0]);
    //         const toDate = date[1] ? utils.modifyCustomerDate(date[1]) : fromDate;
    //         setAffiliatePurchaseDateFrom(fromDate);
    //         setAffiliatePurchaseDateTo(toDate);
    //         setAffiliatePurchaseDate(date)

    //         // Close the calendar if both dates are selected
    //         if (date?.length > 1 && date[1] != null) {
    //             affiliateCalendarRef.current.hide();
    //         }
    //     }
    //     setAffiliateData(false)
    // };

    const trimFormData = (val) => {
        return val.trim();
    }

    const discountChange = (e) => {
        const newValue = e.value;
        setDiscountValue(newValue);
    }

    useEffect(() => {
        if (discountValue <= 100) {
            setDiscountError("");
        } else {
            setDiscountError("Value must not exceed 100");
        }
    }, [discountValue]);

    const updateAPIDisable = (rowData) => {
        setEnableLoading(true)
        const request = {
            "affiliate": {
                "afId": rowData?.afId,
                "name": rowData?.name,
                "id": rowData?.id,
                "b2bApiEnabled": disableText === 'Enable API' ? true : false,
            }
        }
        updateAffiliates(request, headers, dispatch, (response) => {
            setEnableLoading(false)
            if (response.result === "SUCCESS") {
                setEnable(false);
                setDisableText(disableText === 'Enable API' ? 'Disable API' : 'Enable API')
                getAllAffiliateUsers()
                setDurationValue('')
                setPermanentDiscount('')
                setDiscountValue('')
                setDiscountError('')
                setDurationError("")
                toast.current.show({
                    severity: "success",
                    summary: "Success",
                    detail: `${disableText === 'Disable API' ? "Disabled API successfully" : "Enabled API successfully"}`,
                });
            } else {
                const error = response.error || {};
                setEnableLoading(false)
                toast.current.show({
                    severity: error.severity || "error",
                    summary: "Error",
                    detail: error.errorMsg ? error.errorMsg : error.summary || "An unknown error occurred.",
                });
            }
        });
    }

    const formik1 = useFormik({
        initialValues: initialValues1,
        validationSchema: validationSchema1,
        onSubmit: (values) => {
            handleSubmit(values); // Submit for the first form
        },
    });

    const formik2 = useFormik({
        initialValues: initialValues2,
        validationSchema: validationSchema2(roles),
        onSubmit: (values) => {
            handleFormSubmit(values); // Submit for the second form
        },
    });

    const header = isReadOnly
        ? "Affiliate Information"
        : Number(formik2.values.type) === 2
            ? "Create Affiliate user"
            : "Create Affiliate";

    const affiliateStatusOptions = [
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ];

    const AFFILIATE_TYPES = {
        STANDARD: "0",
        CORPORATE: "1",
        SUB_USER: "2"
    };

    const handleRowClick = (e) => {
        const isExpanderClicked = e.originalEvent.target.closest('.p-row-toggler');
        if (isExpanderClicked) return;

        const rowData = e.data;

        if (rowData?.name && rowData?.isActive) {
            setExpandedRows((prev) => {
                const isAlreadyExpanded = prev.includes(rowData.id);
                return isAlreadyExpanded
                    ? prev.filter(id => id !== rowData.id)
                    : [...prev, rowData.id];
            });
        }
    };

    const onRowToggle = (e) => {
        const validExpandedRows = e.data.filter(row => row.isActive === true).map(row => row.id);
        setExpandedRows(validExpandedRows);
    };

    const rowExpansionTemplate = (rowData) => {
        return (
            <div className="card">
                <PR.DataTable value={rowData?.affiliateUsers || []} dataKey="id" className="affiliate-expansion-table" emptyMessage={<span className="text-gray-500">No affiliate users found</span>}>
                    <PR.Column style={{ width: "2%" }} className="toggler-expander" />
                    <PR.Column className="batch-column" style={{ width: "13%" }} />
                    <PR.Column
                        body={(row) => (
                            <>
                                <div className="aff-data">
                                    {row?.name || "-"} <br />
                                    <span>{getRoleName(row?.role)}</span>
                                </div>
                            </>
                        )}
                        style={{ width: "10%" }}
                    />
                    <PR.Column
                        body={(row) => (
                            <span className="email-column">{row?.email || "-"}</span>
                        )}
                        style={{ width: "17%" }}
                    />
                    <PR.Column
                        style={{ width: "8%" }}
                        className="discount-column"
                        headerClassName="discount-header"
                    />
                    <PR.Column body={userStatus} header="Status" sortable style={{ width: "6%" }} className="discount-column" headerClassName="discount-header" />
                    <PR.Column header="B2B API" style={{ width: "6%" }} className="discount-column" headerClassName="discount-header" />
                    <PR.Column header="Actions" style={{ width: "9%" }} className="actions-column" />
                </PR.DataTable>
            </div>
        );
    };

    const status = (rowData) => {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <PR.InputSwitch checked={rowData.isActive} onChange={() => handleCheckboxChange(rowData)} />
            </div>
        )
    };

    const userStatus = (rowData) => {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <PR.InputSwitch checked={rowData.isActive} onChange={() => handleActivateUserSubmit(rowData)} />
            </div>
        )
    };

    const b2bAPI = (rowData) => {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <PR.InputSwitch checked={rowData.b2bApiEnabled === true} onChange={(e) => handleAPISwitchBox(rowData, e.value)} />
            </div>
        )
    };

    const reportValidationSchema = Yup.object().shape({
        reportType: Yup.string().required("Please select report type"),
        customMonth: Yup.date()
            .nullable()
            .when("reportType", {
                is: "custom",
                then: (schema) => schema.required("Please select month"),
                otherwise: (schema) => schema.nullable(),
            }),
    });

    const initialReportValues = {
        reportType: "",
        customDate: "",
    };

    const downloadSettlementReport = (values, setSubmitting) => {
        const timeStamp = getCurrentTimestamp()
        let payload = {};

        if (values.reportType === "custom" && values.customMonth) {
            const selectedDate = new Date(values.customMonth);
            const month = selectedDate.getMonth() + 1; // JS months are 0-indexed
            const year = selectedDate.getFullYear();

            payload = {
                affiliateId: settlementAffiliateID,
                month,
                year,
            };
        } else if (values.reportType === "current") {
            const today = new Date();
            payload = {
                affiliateId: settlementAffiliateID,
                month: today.getMonth() + 1,
                year: today.getFullYear(),
            };
        } else if (values.reportType === "last") {
            const today = new Date();
            const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            payload = {
                affiliateId: settlementAffiliateID,
                month: lastMonth.getMonth() + 1,
                year: lastMonth.getFullYear(),
            };
        }
        getSettlementReport(payload, headers, dispatch, response => {
            if (response.result === 'SUCCESS') {
                const csvData = response.data;
                const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", `bo.${appName}-settlement-report-${timeStamp}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setSettlementReport(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Settlement Report Exported successfully' });
            } else {
                const error = response.error;
                toast.current.show({ severity: error.severity, summary: 'Error', detail: (error.errorMsg) ? error.errorMsg : error.summary })
            }
            setLoading(false);
            setSubmitting(false);
        })
    }

    const handleAffiliateInfo = (values) => {
        formik2.setValues({
            type: values?.type === 0 ? AFFILIATE_TYPES.STANDARD : AFFILIATE_TYPES.CORPORATE,
            affiliateId: values?.afId,
            name: values?.affiliateUsers[0]?.name || '',
            lastName: values?.affiliateUsers[0]?.lastName || '',
            email: values?.affiliateUsers[0]?.email || '',
            phoneNumber: values?.affiliateUsers[0]?.phoneNumber || '',
            callingCode: values?.affiliateUsers[0]?.callingCode || '+44',
            websites: values?.websites || [],
            b2bApiEnabled: values?.b2bApiEnabled || false,
            affiliateName: values?.name || '',
            canSeeUsers: values?.canSeeUsers === true ? "show" : "hide",
        });
        setDiscountValue((values?.voucherCreationDiscountPercent))
        setCommissionValue((values?.perOrderCommissionPercent))
        setPermanentDiscount(values?.permanentDiscountPercentage)
        setDurationValue(values?.revenueRecognitionPeriodInDays)
        setIsReadOnly(true);
        setCreateAffiliate(true)
    }

    const actions = (rowData) => {
        return <div onClick={(e) => e.stopPropagation()}>{<>
            <div ref={(el) => qrRef.current[rowData.id] = el} style={{ display: 'none' }} >
                <QRCode
                    id={rowData.afId}
                    value={getUrl(rowData.afId)}
                    size={500}
                    logoImage={`brands/${appName}-icon.png`}
                    logoWidth={50}
                    logoHeight={50}
                />
            </div>
            <i
                className="pi pi-qrcode"
                title="Download QR Code"
                style={{ color: 'red', marginRight: '0.7rem', cursor: 'pointer' }}
                onClick={() => downloadQRCode(rowData.id)}
            />

            <i
                className="pi pi-download"
                title="Download Settlement Report"
                style={{ color: 'red', marginRight: '0.7rem', cursor: 'pointer' }}
                onClick={() => {
                    setSettlementReport(true);
                    setSettlementAffiliateID(rowData.id);
                }}
            />
        </>
        }
            {<i
                className="pi pi-copy"
                title="Copy Affiliate Link"
                style={{ color: 'red', cursor: 'pointer' }}
                onClick={() => handleCopyClipboard(rowData.afId)}
            />
            }
            {<i
                className="pi pi-info-circle ml-2"
                title="Affiliate Info"
                style={{ color: 'red', cursor: 'pointer' }}
                onClick={() => handleAffiliateInfo(rowData)}
            />
            }
        </div>
    };

    return (
        <>
            <div className="main">
                <div className="layout-sidebar">
                    <AdminHeader />
                </div>
                <div className="layout-content-wrapper">
                    <section className="admin-affiliateslist-section">
                        <div className="grid grid-nogutter">
                            <div className="col-12">
                                <div className="heading-sec">
                                    <div className="flex align-items-center justify-content-between m-flex">
                                        <h1>Affiliate Management</h1>
                                        <div className="right-section flex align-items-center gap-3">
                                            <PR.Button
                                                label="Create Affiliate"
                                                className="export-button"
                                                icon="pi pi-plus"
                                                iconPos="left"
                                                onClick={() => setCreateAffiliate(true)}
                                                disabled={loading}
                                            />
                                            <PR.Button text className="filter-toggle-button" onClick={toggleFilter}>
                                                <i className={`pi ${filterOpen ? "pi-filter-slash" : "pi-filter-fill"}`}></i>
                                            </PR.Button>
                                        </div>
                                    </div>
                                    <div className={`filter-right justify-content-between ${filterOpen ? "mobile-filter-section" : ""}`}>
                                        <form autoComplete="off" onSubmit={formik1.handleSubmit}>
                                            <div className='flex align-items-center mobile-flex'>
                                                <div className="users-search-input">
                                                    <span>
                                                        <PR.InputText placeholder="Affiliate Name" name="searchAffiliateName" onChange={formik1.handleChange} onBlur={formik1.handleBlur} value={formik1.values.searchAffiliateName} autoComplete="off" />
                                                    </span>
                                                    {formik1.errors.searchAffiliateName && formik1.touched.searchAffiliateName
                                                        ? <div className='error-message'>{formik1.errors.searchAffiliateName}</div>
                                                        : ''
                                                    }
                                                </div>

                                                {/* <div className="users-search-input">
                                                    <span>
                                                        <PR.InputText placeholder="User Name" name="searchUserName" onChange={formik1.handleChange} onBlur={formik1.handleBlur} value={formik1.values.searchUserName} autoComplete="off" />
                                                    </span>
                                                    {formik1.errors.searchUserName && formik1.touched.searchUserName
                                                        ? <div className='error-message'>{formik1.errors.searchUserName}</div>
                                                        : ''
                                                    }
                                                </div> */}

                                                <div className="users-search-input">
                                                    <span>
                                                        <PR.InputText placeholder="Email ID" name="searchAffiliateEmail" onChange={formik1.handleChange} onBlur={formik1.handleBlur} value={formik1.values.searchAffiliateEmail} autoComplete="off" />
                                                    </span>
                                                    {formik1.errors.searchAffiliateEmail && formik1.touched.searchAffiliateEmail
                                                        ? <div className='error-message'>{formik1.errors.searchAffiliateEmail}</div>
                                                        : ''
                                                    }
                                                </div>

                                                <div className="users-search-input">
                                                    <span>
                                                        <PR.InputText placeholder="Phone Number" name="searchAffiliatePhone"
                                                            onChange={(e) => utils.handlePhoneChange(e, formik1, 'searchAffiliatePhone')}
                                                            onBlur={formik1.handleBlur} value={formik1.values.searchAffiliatePhone} autoComplete="off" />
                                                    </span>
                                                    {formik1.errors.searchAffiliatePhone && formik1.touched.searchAffiliatePhone
                                                        ? <div className='error-message'>{formik1.errors.searchAffiliatePhone}</div>
                                                        : ''
                                                    }
                                                </div>

                                                <div className="users-search-input">
                                                    <span>
                                                        <PR.MultiSelect filter resetFilterOnHide value={affiliateStatus} options={affiliateStatusOptions} onChange={(e) => handleAffiliateSelectedStatus(e.value)} name="searchOrderStatus" optionLabel="label" placeholder="Status" maxSelectedLabels={1} />
                                                    </span>
                                                    {formik1.errors.searchOrderStatus && formik1.touched.searchOrderStatus
                                                        ? <div className='error-message'>{formik1.errors.searchOrderStatus}</div>
                                                        : ''
                                                    }
                                                </div>

                                                {/* <div className="users-search-input">
                                                    <span>
                                                        <PR.Calendar panelClassName="datte-range-calendar" value={affiliatePurchaseDate} onChange={handleAffiliateSelectedDate} selectionMode="range" readOnlyInput placeholder="Date Range" name="searchPurchaseDate" dateFormat="dd-mm-yy" maxDate={currentDate} showIcon showButtonBar numberOfMonths={2} ref={affiliateCalendarRef} className="customers-daterange" />
                                                    </span>
                                                    {formik1.errors.searchPurchaseDate && formik1.touched.searchPurchaseDate
                                                        ? <div className='error-message'>{formik1.errors.searchPurchaseDate}</div>
                                                        : ''
                                                    }
                                                </div> */}

                                                <div className="users-search-input laptop-btns-block">
                                                    <span>
                                                        <PR.Button label="Search" type='submit' className="searchBtn" />
                                                        <PR.Button label="Reset" type='reset' className="resetBtn" onClick={resetUserForm} />
                                                    </span>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="users-data-table card">
                            <div className="card">
                                <PR.DataTable
                                    loading={loading}
                                    value={users}
                                    expandedRows={users.filter(user => expandedRows.includes(user.id))}
                                    onRowClick={handleRowClick}
                                    onRowToggle={onRowToggle}
                                    rowExpansionTemplate={rowExpansionTemplate}
                                    className="vouchers-table affiliate-management-table"
                                    emptyMessage={<span className="text-gray-500">No results found</span>}
                                    rowClassName={(rowData) => !rowData.isActive ? 'disabled-row' : ''}
                                >
                                    <PR.Column expander style={{ width: "2%" }} />
                                    <PR.Column
                                        header={() => affiliatesDataHeader("name", "Affiliate Name", "affiliateUserName")}
                                        className="batch-column"
                                        body={(rowData) => (
                                            <>
                                                <div className="aff-data" onClick={(e) => e.stopPropagation()}>
                                                    {rowData.name} <br />
                                                    <span>{rowData.type === 0 ? "Standard affiliate" : "Corporate affiliate"}</span>
                                                </div>
                                            </>
                                        )}
                                        style={{ width: "13%" }}
                                    />
                                    <PR.Column
                                        header="User Name"
                                        headerStyle={{ cursor: "default" }}
                                        body={(rowData) => {
                                            const isDisabled = !rowData?.isActive;

                                            return (
                                                <div className="batch-p">
                                                    {!isDisabled && (
                                                        <div className="flex align-items-center gap-3">
                                                            <span className="click-text">Click here to view affiliate users</span>
                                                            <button
                                                                type="button"
                                                                className="p-button p-button-sm add-user"
                                                                onClick={() => {
                                                                    setCreateAffiliate(true);
                                                                    formik2.setFieldValue("type", "2");
                                                                    formik2.setFieldValue("affiliateName", rowData?.name)
                                                                    setRoles(rowData?.type)
                                                                }}
                                                            >
                                                                + Add New User
                                                            </button>
                                                        </div>
                                                    )}
                                                    {isDisabled && (
                                                        <span className="disabled-text">Affiliate Disabled</span>
                                                    )}
                                                </div>
                                            );
                                        }}
                                        style={{ width: "10%" }}
                                    />
                                    <PR.Column
                                        header="Email"
                                        headerStyle={{ cursor: "default" }}
                                        style={{ width: "17%" }}
                                    />
                                    <PR.Column
                                        header="Commission / Discount"
                                        headerStyle={{ cursor: "default" }}
                                        body={(rowData) => {
                                            const value = rowData?.type === 0
                                                ? (rowData?.perOrderCommissionPercent)
                                                : (rowData?.voucherCreationDiscountPercent)
                                            return (
                                                <div onClick={(e) => e.stopPropagation()}>
                                                    {`${value}%`}
                                                </div>
                                            )
                                        }}
                                        style={{ width: "8%" }}
                                        className="discount-column"
                                        headerClassName="discount-header"
                                    />
                                    <PR.Column body={status} header={affiliatesDataHeader('isActive', 'Status', 'affiliateUserStatus')} style={{ width: "6%" }} className="discount-column" headerClassName="discount-header" />
                                    <PR.Column body={b2bAPI} headerStyle={{ cursor: "default" }} header="B2B API" style={{ width: "6%" }} className="discount-column" headerClassName="discount-header" />
                                    <PR.Column body={actions} headerStyle={{ cursor: "default" }} header="Actions" style={{ width: "9%" }} className="actions-column" />
                                </PR.DataTable>
                            </div>
                        </div>
                        <PR.Dialog
                            visible={isDialogVisible}
                            dismissableMask={true}
                            draggable={false}
                            resizable={false}
                            header="Activate Affiliate"
                            onHide={() => { setDialogVisible(false); setDiscountError(""); setCommissionError(""); setDiscountValue(''); setDurationValue(''); setPermanentDiscount('') }}
                            className="affiliate-dialog"
                            maskClassName="affiliate-dialog-mask"
                        >
                            <div>
                                <p>By clicking on confirm, you are activating the <br /> <strong>{affiliateNameActivate}</strong> account.</p>
                                {allValues?.type === 0 &&
                                    <>
                                        <div className="flex align-items-center justify-content-between mt-3 w-11">
                                            <label htmlFor="revenue-recognition">Set revenue recognition period</label>
                                            <div className="relative">
                                                <PR.InputNumber
                                                    value={durationValue}
                                                    onValueChange={(e) => setDurationValue(e.value)}
                                                    min={0}
                                                    inputId="revenue-recognition"
                                                    className="days-input"
                                                />
                                                <span className="days-span">days</span>
                                            </div>
                                        </div>
                                        <div className="flex align-items-center justify-content-between mt-3 w-11">
                                            <label htmlFor="revenue-recognition">Set Commission</label>
                                            <div className="relative">
                                                <PR.InputNumber
                                                    value={allValues?.commission}
                                                    onValueChange={(e) => {
                                                        setAllValues((prev) => ({ ...prev, commission: e.value }));
                                                    }}
                                                    min={0}
                                                    max={100}
                                                    inputId="revenue-recognition"
                                                    className="percentage-input"
                                                />
                                                <span className="days-span">%</span>
                                            </div>
                                        </div>
                                        {commissionError !== "" ? <small className="p-error">{commissionError}</small> : null}
                                        <div className="flex align-items-center justify-content-between mt-3 w-11">
                                            <label htmlFor="discount-value">Permanent Discount</label>
                                            <div className="relative">
                                                <PR.InputNumber
                                                    value={permanentDiscount}
                                                    onValueChange={(e) => setPermanentDiscount(e.value)}
                                                    min={0}
                                                    max={100}
                                                    inputId="activateDiscountValue"
                                                    className="percentage-input"
                                                />
                                                <span className="days-span">%</span>
                                            </div>
                                        </div>
                                    </>
                                }
                                {allValues?.type === 1 &&
                                    <>
                                        <div className="flex align-items-center justify-content-between mt-3 w-11">
                                            <label htmlFor="discount-value">Discount value</label>
                                            <div className="relative">
                                                <PR.InputNumber
                                                    value={allValues?.discount}
                                                    onValueChange={(e) => {
                                                        setAllValues((prev) => ({ ...prev, discount: e.value }));
                                                    }}
                                                    min={0}
                                                    max={100}
                                                    inputId="activateDiscountValue"
                                                    className="percentage-input"
                                                />
                                                <span className="days-span">%</span>
                                            </div>
                                        </div>
                                        {discountError !== "" ? <small className="p-error">{discountError}</small> : null}
                                        <div className="flex align-items-center justify-content-between mt-3 w-11">
                                            <label htmlFor="revenue-recognition">User information in order</label>
                                            <PR.Dropdown
                                                value={allValues.seeUser ? "show" : "hide"}
                                                onChange={(e) => {
                                                    const isShow = e.value === "show";
                                                    setAllValues((prev) => ({ ...prev, seeUser: isShow }));
                                                }}
                                                options={[
                                                    { label: "Show", value: "show" },
                                                    { label: "Hide", value: "hide" }
                                                ]}
                                                optionLabel="label"
                                                optionValue="value"
                                                className="show-hide-dropdown"
                                            />
                                        </div>
                                    </>
                                }
                                <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                                    <PR.Button onClick={() => setDialogVisible(false)} label="Cancel" className="confirm-button reset-btn min-width" />
                                    <PR.Button onClick={handleActivateSubmit} label="Confirm" className="confirm-button min-width" />
                                </div>
                            </div>
                        </PR.Dialog>

                        <PR.Dialog
                            visible={isDeactivationDialogVisible}
                            dismissableMask={true}
                            draggable={false}
                            resizable={false}
                            header="Confirm Deactivation"
                            onHide={() => setDeactivationDialogVisible(false)}
                            className="affiliate-dialog"
                            maskClassName="affiliate-dialog-mask"
                        >
                            <p>Are you sure you want to deactivate this affiliate?</p>
                            <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                                <PR.Button onClick={() => setDeactivationDialogVisible(false)} label="No" className="confirm-button  reset-btn min-width" />
                                <PR.Button onClick={handleDeactivate} label="Yes" className="confirm-button min-width" />
                            </div>
                        </PR.Dialog>
                        {users.length > 0 ? (
                            <div className="pagination">
                                <button
                                    type="button"
                                    onClick={() => paginate(page - 1)}
                                    className={paging ? page <= 1 ? "disabled" : "pagination-button" : "disabled"}
                                >
                                    {globalConfig.pagination_Previous}
                                </button>
                                <span className="active"> {page} </span>
                                <button
                                    type="button"
                                    onClick={() => paginate(page + 1)}
                                    className={paging ? last ? "disabled" : "pagination-button" : "disabled"}
                                >
                                    {globalConfig.pagination_Next}
                                </button>
                            </div>
                        ) : (
                            <></>
                        )}
                        <PR.Toast ref={toast} position='top-right' />
                    </section>
                    <AdminFooter />
                </div>
                <PR.Dialog
                    header={"Download Settlement Report"}
                    visible={settlementReport}
                    draggable={false}
                    resizable={false}
                    onHide={onHideHandler}
                    dismissableMask={true}
                    maskClassName="create-voucher-dialog-mask"
                    className="filter-dialog order-filters-dialog report-download-dialog"
                >
                    <div className="card">
                        <p className="text-sm text-gray-500 mb-5 p-text-tag">
                            Please choose an option to download.
                        </p>
                        <Formik
                            initialValues={initialReportValues}
                            validationSchema={reportValidationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                downloadSettlementReport(values, setSubmitting);
                            }}
                        >
                            {({ values, setFieldValue, isSubmitting }) => (
                                <Form className="flex flex-column gap-3">
                                    {/* Radio Buttons Section */}
                                    <div className="flex flex-column gap-3">
                                        <div className="flex align-items-center gap-2">
                                            <Field
                                                type="radio"
                                                name="reportType"
                                                value="current"
                                                as={PR.RadioButton}
                                                inputId="currentMonth"
                                            />
                                            <label htmlFor="currentMonth">Current month</label>
                                        </div>

                                        <div className="flex align-items-center gap-2">
                                            <Field
                                                type="radio"
                                                name="reportType"
                                                value="last"
                                                as={PR.RadioButton}
                                                inputId="lastMonth"
                                            />
                                            <label htmlFor="lastMonth">Last month</label>
                                        </div>

                                        <div className="flex align-items-center gap-2">
                                            <Field
                                                type="radio"
                                                name="reportType"
                                                value="custom"
                                                as={PR.RadioButton}
                                                inputId="custom"
                                            />
                                            <label htmlFor="custom">Custom</label>
                                        </div>

                                        <ErrorMessage
                                            name="reportType"
                                            component="div"
                                            className="p-error text-sm mt-1"
                                        />
                                    </div>

                                    {/* Custom Date Field */}
                                    {values.reportType === "custom" && (
                                        <div>
                                            <PR.Calendar
                                                id="customMonth"
                                                value={values.customMonth}
                                                onChange={(e) => setFieldValue("customMonth", e.value)}
                                                view="month"
                                                dateFormat="mm/yy"
                                                yearNavigator
                                                monthNavigator
                                                yearRange={`2024:${currentYear}`} // always start from 2024 up to current year
                                                minDate={new Date(2024, 0, 1)}    // Jan 2024
                                                maxDate={new Date()}               // today
                                                showIcon
                                                placeholder="Select Month/Year"
                                            />
                                            <ErrorMessage
                                                name="customMonth"
                                                component="div"
                                                className="p-error text-sm mt-1"
                                            />
                                        </div>
                                    )}

                                    {/* Download Button */}
                                    <div className="text-right mt-3 buttons-sections">
                                        <PR.Button
                                            type="button"
                                            label="Cancel"
                                            className="confirm-button reset-btn min-width mr-3"
                                            onClick={() => setSettlementReport(false)}
                                        />
                                        <PR.Button
                                            type="submit"
                                            label="Download"
                                            className="confirm-button min-width"
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>

                </PR.Dialog>
                <PR.Dialog
                    header={header}
                    visible={createAffiliate}
                    draggable={false}
                    resizable={false}
                    onHide={onHideHandler}
                    dismissableMask={true}
                    maskClassName="create-voucher-dialog-mask"
                    className="filter-dialog voucher-modal create-voucher-dialog create-affiliate-dialog"
                >
                    <form className="filter-content create-affiliate" onSubmit={formik2.handleSubmit}>
                        {formik2.values.type !== "2" &&
                            <div className="grid mt-2">
                                <div className="col-12 md:col-6">
                                    <div className="relative">
                                        <div className="flex align-items-center">
                                            <p className="mb-2">Affiliate Type<span className="validation-required">*</span></p>
                                            <i
                                                className="pi pi-info-circle info-icon"
                                                data-pr-tooltip={
                                                    `1. Standard Affiliate: \n An individual or influencer who promotes and helps sell eSIMs in return for commission on successful sales or referrals.\n\n` +
                                                    `2. Corporate Affiliate:\n A business or organization that receives discounted eSIM rates for internal use (e.g., employees) and can generate prepaid vouchers for team members.\n\n` +
                                                    `3. Affiliate Sub-User:\n A user under an affiliate account (especially Corporate) who can be assigned specific roles such as Admin, Finance, Voucher Manager, or Voucher Viewer. This allows delegation within a corporate structure.`
                                                }
                                                data-pr-position="bottom"
                                                data-pr-classname="affiliate-tooltip"
                                            ></i>
                                            <PR.Tooltip target=".pi-info-circle" />
                                        </div>
                                        <PR.Dropdown
                                            name="type"
                                            value={formik2.values.type}
                                            onChange={(e) => { resetCommon(e) }}
                                            onBlur={formik2.handleBlur}
                                            placeholder="Select Type"
                                            options={[
                                                { label: "Standard Affiliate", value: AFFILIATE_TYPES.STANDARD },
                                                { label: "Corporate Affiliate", value: AFFILIATE_TYPES.CORPORATE },
                                            ]}
                                            optionLabel="label"
                                            optionValue="value"
                                            className="w-full"
                                            disabled={createLoading || isReadOnly}
                                        />
                                    </div>
                                    {formik2.touched.type && formik2.errors.type && (
                                        <small className="p-error">{formik2.errors.type}</small>
                                    )}
                                </div>
                            </div>
                        }
                        <div className="grid mt-2">
                            <div className="col-12 md:col-6">
                                <p className="mb-2">Business/Company Name<span className="validation-required">*</span></p>
                                <PR.InputText
                                    value={formik2.values.affiliateName}
                                    onChange={formik2.handleChange}
                                    onBlur={formik2.handleBlur}
                                    className="w-full"
                                    name="affiliateName"
                                    disabled={createLoading || formik2.values.type === "2" || isReadOnly}
                                />
                                {formik2.touched.affiliateName && formik2.errors.affiliateName && (
                                    <small className="p-error">{formik2.errors.affiliateName}</small>
                                )}
                            </div>
                            {formik2.values.type !== "2" &&
                                <div className="col-12 md:col-6">
                                    <p className="mb-2">Referral Code</p>
                                    <PR.InputText
                                        value={formik2.values.affiliateId}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        className="w-full"
                                        name="affiliateId"
                                        disabled={createLoading || isReadOnly}
                                    />
                                </div>
                            }
                            {formik2.values.type === "2" &&
                                <div className="col-12 md:col-6">
                                    <div className="relative">
                                        <div className="flex align-items-center">
                                            <p className="mb-2">Role</p>
                                            <i
                                                className="pi pi-info-circle info-icon"
                                                data-pr-tooltip={
                                                    `1. Admin\n` +
                                                    `Full access to all features and settings across the platform.\n` +
                                                    `Permissions: Orders, vouchers, user management, and system configuration.\n\n` +

                                                    `2. Finance\n` +
                                                    `Access limited to financial operations such as viewing and managing orders.\n` +
                                                    `Permissions: Orders only.\n\n` +

                                                    `3. Voucher Manager\n` +
                                                    `Can create and manage prepaid vouchers but cannot access order-related data.\n` +
                                                    `Permissions: Create & modify prepaid vouchers only.\n\n` +

                                                    `4. Voucher Viewer\n` +
                                                    `Can view vouchers but cannot create them or access orders.\n` +
                                                    `Permissions: View-only access to vouchers.`
                                                }
                                                data-pr-position="top"
                                                data-pr-classname="affiliate-tooltip"
                                            ></i>
                                            <PR.Tooltip target=".pi-info-circle" />
                                        </div>
                                        <PR.Dropdown
                                            name="role"
                                            value={roles === 0 ? "1" : formik2.values.role}
                                            onChange={(e) => formik2.setFieldValue("role", e.value)}
                                            onBlur={formik2.handleBlur}
                                            placeholder="Select Role"
                                            options={[
                                                { label: "Admin", value: "1" },
                                                { label: "Finance", value: "2" },
                                                { label: "Voucher Manager", value: "3" },
                                                { label: "Voucher Viewer", value: "4" }
                                            ]}
                                            optionLabel="label"
                                            optionValue="value"
                                            className="w-full"
                                            disabled={createLoading || roles === 0}
                                        />
                                    </div>
                                    {formik2.touched.role && formik2.errors.role && (
                                        <small className="p-error">{formik2.errors.role}</small>
                                    )}
                                </div>
                            }
                        </div>
                        <div className="grid mt-2">
                            <div className="col-12 md:col-6">
                                <p className="mb-2">User Name<span className="validation-required">*</span></p>
                                <PR.InputText
                                    value={formik2.values?.name || ""}
                                    keyfilter={/^[a-zA-Z0-9-_ ]*$/}
                                    onChange={formik2.handleChange}
                                    onBlur={formik2.handleBlur}
                                    placeholder="Enter First name"
                                    className="w-full"
                                    name="name"
                                    disabled={createLoading || isReadOnly}
                                />
                                {formik2.touched.name && formik2.errors.name && (
                                    <small className="p-error">{formik2.errors.name}</small>
                                )}
                            </div>
                            {formik2.values.type !== "2" &&
                                <div className="col-12 md:col-6">
                                    <p className="mb-2">Supported websites (Optional)</p>
                                    <PR.Chips
                                        value={formik2.values.websites || ""}
                                        onChange={(e) => {
                                            formik2.setFieldValue("websites", e.value);
                                        }}
                                        onBlur={formik2.handleBlur}
                                        placeholder="Supported Websites/Advertising Location"
                                        className="w-full"
                                        name="websites"
                                        addOnBlur={true}
                                        allowDuplicate={false}
                                        disabled={createLoading || isReadOnly}
                                    />
                                </div>
                            }
                            {formik2.values.type === "2" &&
                                <div className="col-12 md:col-6">
                                    <p className="mb-2">Email<span className="validation-required">*</span></p>
                                    <PR.InputText
                                        value={formik2.values.email || ""}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        placeholder="Enter Email address"
                                        className="w-full"
                                        name="email"
                                        disabled={createLoading}
                                    />
                                    {formik2.touched.email && formik2.errors.email && (
                                        <small className="p-error">{formik2.errors.email}</small>
                                    )}
                                </div>
                            }
                        </div>
                        <div className="grid mt-2">
                            {formik2.values.type !== "2" &&
                                <div className="col-12 md:col-6">
                                    <p className="mb-2">Email<span className="validation-required">*</span></p>
                                    <PR.InputText
                                        value={formik2.values.email || ""}
                                        onChange={formik2.handleChange}
                                        onBlur={formik2.handleBlur}
                                        placeholder="Enter Email address"
                                        className="w-full"
                                        name="email"
                                        disabled={createLoading || isReadOnly}
                                    />
                                    {formik2.touched.email && formik2.errors.email && (
                                        <small className="p-error">{formik2.errors.email}</small>
                                    )}
                                </div>
                            }
                            <div className="col-12 md:col-6">
                                <p className="mb-2">Phone number(Optional)</p>
                                <PhoneInput
                                    inputProps={{
                                        name: "phone",
                                        required: true,
                                        id: "phone-input",
                                    }}
                                    countryCodeEditable={false}
                                    autoFormat={true}
                                    enableSearch={true}
                                    searchPlaceholder="Search"
                                    onBlur={formik2.handleBlur}
                                    placeholder="Enter Phone number"
                                    country={iso} // Default country: UK (ISO code "gb")
                                    value={formik2.values.phone || ""}
                                    onChange={(value, data) => {
                                        let phoneValue = `+${value}`.replace(`+${data.dialCode}`, "");
                                        phoneValue = removeLeadingZero(phoneValue);
                                        formik2.setFieldValue("phoneNumber", `${phoneValue}`);
                                        setPhoneValue(phoneValue);
                                        formik2.setFieldValue("callingCode", `+${data.dialCode}`);
                                    }}
                                    isValid={(country) => {
                                        if (country === 0) {
                                            setIso("gb"); // Default to UK if no country detected
                                        }
                                        return true;
                                    }}
                                    style={{ width: "100%" }}
                                    disabled={createLoading || isReadOnly}
                                />
                            </div>
                        </div>

                        {(formik2.values.type === "0" || formik2.values.type === "1") &&
                            <p className="parameters-p-tag"><span>Additional Parameters</span></p>
                        }

                        {formik2.values.type === "0" &&
                            <div className="grid mt-2">
                                <div className="col-12 md:col-4">
                                    <div className="relative">
                                        <p className="mb-2">Commission<span className="validation-required">*</span></p>
                                        <PR.InputNumber
                                            value={commissionValue}
                                            onValueChange={(e) => {
                                                setCommissionValue(e.value)
                                                if (e.value !== null && e.value !== '') {
                                                    setCommissionError('');
                                                }
                                            }}
                                            min={0}
                                            mode="decimal"
                                            minFractionDigits={0}
                                            maxFractionDigits={0}
                                            max={100}
                                            inputId="commission"
                                            className="days-input"
                                            disabled={createLoading || isReadOnly}
                                        />
                                        <span className="label-position">%</span>
                                    </div>
                                    {commissionError !== "" ? <small className="p-error">{commissionError}</small> : null}
                                </div>

                                <div className="col-12 md:col-4">
                                    <div className="relative">
                                        <p className="mb-2">Permanent Discount</p>
                                        <PR.InputNumber
                                            value={permanentDiscount}
                                            onValueChange={(e) => {
                                                setPermanentDiscount(e.value)
                                                /*  if (e.value !== null && e.value !== '') {
                                                     setCommissionError('');
                                                 } */
                                            }}
                                            min={0}
                                            max={100}
                                            inputId="permanentDiscount"
                                            className="days-input"
                                            disabled={createLoading || isReadOnly}
                                        />
                                        <span className="label-position">%</span>
                                    </div>
                                </div>

                                <div className="col-12 md:col-4">
                                    <div className="relative">
                                        <div className="flex align-items-center">
                                            <p className="mb-2">Revenue recognition period<span className="validation-required">*</span></p>
                                            {/* <i
                                                className="pi pi-info-circle info-icon"
                                                data-pr-tooltip="This is RRP"
                                                data-pr-position="bottom"
                                            ></i>
                                            <PR.Tooltip target=".pi-info-circle" /> */}
                                        </div>
                                        <PR.InputNumber
                                            value={durationValue}
                                            onValueChange={(e) => {
                                                setDurationValue(e.value)
                                                if (e.value !== null && e.value !== '') {
                                                    setDurationError('');
                                                }
                                            }}
                                            min={0}
                                            inputId="revenue-recognition"
                                            className="days-input"
                                            disabled={createLoading || isReadOnly}
                                        />
                                        <span className="label-position">days</span>
                                    </div>
                                    {durationError !== "" ? <small className="p-error">{durationError}</small> : null}
                                </div>
                            </div>
                        }

                        {formik2.values.type === "1" &&
                            <div className="grid mt-2">
                                <div className="col-12 md:col-6">
                                    <div className="relative">
                                        <p className="mb-2">Discount value<span className="validation-required">*</span></p>
                                        <PR.InputNumber
                                            value={discountValue}
                                            onValueChange={discountChange}
                                            min={0}
                                            mode="decimal"
                                            minFractionDigits={0}
                                            maxFractionDigits={0}
                                            max={100}
                                            inputId="discountValue"
                                            className="percentage-input"
                                            disabled={createLoading || isReadOnly}
                                        />
                                        <span className="label-position">%</span>
                                    </div>
                                    {discountError !== "" ? <small className="p-error">{discountError}</small> : null}
                                </div>
                                <div className="col-12 md:col-6">
                                    <p className="mb-2">User information in order</p>
                                    <PR.Dropdown
                                        name="canSeeUsers"
                                        value={formik2.values.canSeeUsers}
                                        onChange={(e) => formik2.setFieldValue("canSeeUsers", e.value)}
                                        onBlur={formik2.handleBlur}
                                        placeholder="Show or Hide"
                                        options={[
                                            { label: "Show", value: "show" },
                                            { label: "Hide", value: "hide" }
                                        ]}
                                        optionLabel="label"
                                        optionValue="value"
                                        className="w-full"
                                        disabled={createLoading || isReadOnly}
                                    />
                                    {formik2.touched.canSeeUsers && formik2.errors.canSeeUsers && (
                                        <small className="p-error">{formik2.errors.canSeeUsers}</small>
                                    )}
                                </div>
                            </div>
                        }

                        {(formik2.values.type === "0" || formik2.values.type === "1") &&
                            <div className="col-12 md:col-12">
                                <div>
                                    <label htmlFor="revenue-recognition" className="label-text">Enable B2B API</label>
                                    <PR.Checkbox
                                        inputId="b2bApiEnabled"
                                        name="b2bApiEnabled"
                                        checked={formik2.values.b2bApiEnabled}
                                        onChange={formik2.handleChange}
                                        onBlur={formik1.handleBlur}
                                        label="Enable B2B API"
                                        disabled={isReadOnly}
                                    />
                                    {/* <i
                                        className="pi pi-info-circle info-icon"
                                        data-pr-tooltip="This is B2B"
                                        data-pr-position="bottom"
                                    ></i>
                                    <PR.Tooltip target=".pi-info-circle" /> */}
                                </div>
                            </div>
                        }


                        <div>
                            <div className="buttons-sections flex align-items-center justify-content-between gap-3 mt-3">
                                <p></p>
                                <div className="flex align-items-center gap-3">
                                    <PR.Button
                                        label="Reset"
                                        type="button"
                                        className="confirm-button reset-btn min-width"
                                        disabled={createLoading || isReadOnly}
                                        onClick={resetHandler}
                                    />
                                    <PR.Button
                                        label="Create"
                                        type="submit"
                                        className="confirm-button min-width"
                                        disabled={createLoading || isReadOnly}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </PR.Dialog>

                <PR.Dialog
                    visible={enable}
                    dismissableMask={true}
                    draggable={false}
                    resizable={false}
                    header={disableText === 'Disable API' ? 'Disable API' : 'Enable API'}
                    onHide={() => setEnable(false)}
                    className="affiliate-dialog"
                    maskClassName="affiliate-dialog-mask"
                >
                    <p>Are you sure you want to {disableText === 'Disable API' ? 'Disable' : 'Enable'} this API?</p>
                    <div className="dialog-footer buttons-sections flex gap-3 align-items-center justify-content-end">
                        <PR.Button onClick={() => setEnable(false)} label="No" className="confirm-button  reset-btn min-width" disabled={enableLoading} />
                        <PR.Button onClick={() => { if (enableAPI) { updateAPIDisable(enableAPI) } }} label="Yes" className="confirm-button min-width" disabled={enableLoading} />
                    </div>
                </PR.Dialog>
            </div>
        </>
    );
};

export default Affiliates;